import * as React from 'react';

const PrimeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#FF8940"
      stroke="#E65800"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.833 5.083a1.7 1.7 0 0 1-.915-.918v.003l-.603-1.455a1.694 1.694 0 0 0-2.213-.916l-1.454.6a1.7 1.7 0 0 1-1.296 0l-1.454-.601a1.694 1.694 0 0 0-2.213.916l-.602 1.455a1.7 1.7 0 0 1-.917.915l-1.453.602a1.694 1.694 0 0 0-.917 2.213l.6 1.456c.173.415.173.88.002 1.296l-.602 1.453a1.694 1.694 0 0 0 .917 2.212l1.454.603c.415.172.744.502.916.917l.603 1.455a1.694 1.694 0 0 0 2.211.916l1.455-.602c.414-.172.88-.172 1.296 0l1.453.601a1.693 1.693 0 0 0 2.213-.916l.602-1.455c.173-.415.503-.744.918-.915l1.453-.602a1.695 1.695 0 0 0 .917-2.214l-.601-1.453a1.7 1.7 0 0 1 0-1.297l.601-1.454a1.694 1.694 0 0 0-.916-2.213z"
    ></path>
    <path
      stroke="#331400"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m7.5 10 1.667 1.667 3.75-3.75"
    ></path>
  </svg>
);

export default PrimeIcon;
